var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#ECE9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8333 16.3335C21.0343 16.3335 16.3333 21.0345 16.3333 26.8335C16.3333 32.6325 21.0343 37.3335 26.8333 37.3335C29.3125 37.3335 31.591 36.4743 33.3873 35.0374L37.675 39.3251C38.1306 39.7807 38.8693 39.7807 39.325 39.3251C39.7806 38.8695 39.7806 38.1308 39.325 37.6752L35.0372 33.3875C36.4741 31.5912 37.3333 29.3127 37.3333 26.8335C37.3333 21.0345 32.6323 16.3335 26.8333 16.3335ZM18.6667 26.8335C18.6667 22.3232 22.323 18.6668 26.8333 18.6668C31.3437 18.6668 35 22.3232 35 26.8335C35 31.3438 31.3437 35.0002 26.8333 35.0002C22.323 35.0002 18.6667 31.3438 18.6667 26.8335Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon2);
export default __webpack_public_path__ + "static/media/flowIcon2.8dcdddf63e3af47bc53a99c15dbafdcc.svg";
export { ForwardRef as ReactComponent };